import _ from 'lodash';

import ApiService from './ApiService';
export async function applicationSupportUndeleteApplication(params: {
  applicationId: string;
}): Promise<{ success: boolean }> {
  const response = await ApiService.applicationSupportUndeleteApplication(params);
  return response;
}
